export const testAttributes = {
    TABLE_OF_CONTENT_CONTAINER: 'table-of-content-container',
};

export const classAttribute = 'cdm-table-of-content-conatiner';

export const headings = ['h2'];
